<div class="configuration-container">
  <div class="preferences-container">
    <div class="pricing-container">
      <ng-container *ngIf="tier?.priceTierDocument?.configurations">
        <ng-container
          *ngFor="let configuration of tier?.priceTierDocument?.configurations"
        >
          <ng-template
            [ngTemplateOutlet]="renderConfig"
            [ngTemplateOutletContext]="{
              configuration: configuration,
              parentIsActive: true,
            }"
          ></ng-template>
        </ng-container>

        <ng-template
          #renderConfig
          let-configuration="configuration"
          let-parentIsActive="parentIsActive"
        >
          <div class="configuration-definition">
            <span
              *ngIf="warnings[configuration.key]"
              kendoTooltip
              position="top"
            >
              <fa-icon
                class="configuration-warning"
                [icon]="['fas', 'triangle-exclamation']"
                [title]="warnings[configuration.key]"
              >
              </fa-icon>
            </span>

            <kendo-label class="configuration-label">
              {{ configuration.key }}:
            </kendo-label>

            <div class="configuration-value">
              <ng-container [ngSwitch]="configuration.type">
                <ng-container *ngSwitchCase="'numeric'">
                  <kendo-numerictextbox
                    disableMouseWheel
                    class="configuration-input"
                    [disabled]="!parentIsActive"
                    [format]="configuration.format"
                    [min]="0"
                    [decimals]="2"
                    [step]="0.1"
                    [value]="configuration.value"
                    (valueChange)="configuration.value = $event"
                  >
                  </kendo-numerictextbox>
                </ng-container>

                <kendo-textbox
                  *ngSwitchDefault
                  class="configuration-input"
                  [(ngModel)]="configuration.value"
                  [disabled]="!parentIsActive"
                >
                </kendo-textbox>

                <ng-container *ngSwitchCase="'radio'">
                  <label
                    class="configuration-input"
                    *ngFor="let option of configuration.options"
                  >
                    <input
                      type="radio"
                      kendoRadioButton
                      [name]="configuration.key"
                      [value]="option"
                      [(ngModel)]="configuration.value"
                      [disabled]="!parentIsActive"
                    />
                    {{ option }}
                  </label>
                </ng-container>

                <ng-container *ngSwitchCase="'toggle'">
                  <label class="configuration-input">
                    <kendo-switch
                      size="small"
                      [checked]="configuration.value"
                      (valueChange)="
                        configuration.value = $event;
                        toggleConfiguration(configuration, $event)
                      "
                      [disabled]="!parentIsActive"
                    >
                    </kendo-switch>
                  </label>
                </ng-container>
              </ng-container>
            </div>

            <!-- Recursively render child configurations -->
            <div
              class="configuration-children"
              *ngIf="configuration.children?.length"
            >
              <ng-container *ngFor="let child of configuration.children">
                <ng-template
                  [ngTemplateOutlet]="renderConfig"
                  [ngTemplateOutletContext]="{
                    configuration: child,
                    parentIsActive: configuration.is_active,
                  }"
                ></ng-template>
              </ng-container>
            </div>
          </div>
        </ng-template>
      </ng-container>
    </div>
  </div>

  <div class="apply-options">
    <kendo-label
      [for]="updateAllSwitch"
      text="Apply to all tiers"
    ></kendo-label>
    <kendo-switch #updateAllSwitch [(ngModel)]="updateAll"></kendo-switch>
    <button
      kendoButton
      [disabled]="!hasChanged()"
      themeColor="primary"
      (click)="showApply = true"
    >
      Apply
    </button>
  </div>
</div>

<kendo-dialog
  title="Confirm Changes"
  *ngIf="showApply"
  (close)="showApply = false"
>
  Are you sure you want to apply?
  <kendo-dialog-actions>
    <button kendoButton (click)="showApply = false">No</button>
    <button kendoButton (click)="applyChanges()" themeColor="primary">
      Yes
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
